"use client";

/**
 * NotificationsBell — header notification trigger + count badge + popover.
 * Wave 29 stub. Wire to webhooks/events stream in Wave 30+.
 */
import * as React from "react";
import Link from "next/link";

interface Notif { id: string; title: string; body: string; href: string; severity: "info" | "warning" | "blocker"; createdAgo: string }

// Stub notifications — Wave 30+ real-time tRPC subscription
const STUB_NOTIFS: Notif[] = [
  { id: "1", title: "Bioderma Sebium fiyat değişti", body: "Trendyol'da %15 indirim — rakip baskısı tespit edildi", href: "/price-tracker", severity: "warning", createdAgo: "12 dk önce" },
  { id: "2", title: "Eucerin Pigment Control BuyBox kaybedildi", body: "Yeni satıcı 'DermoEczane' kazanıyor — fiyat farkı %8", href: "/buybox-tracker", severity: "blocker", createdAgo: "1 saat önce" },
  { id: "3", title: "Nivea Q10 stok uyarısı", body: "n11'de son 5 ünite kaldı — 24 saat içinde tükenecek", href: "/inbox", severity: "warning", createdAgo: "3 saat önce" },
];

export function NotificationsBell(): React.JSX.Element {
  const [open, setOpen] = React.useState(false);
  const rootRef = React.useRef<HTMLDivElement>(null);
  const count = STUB_NOTIFS.length;

  React.useEffect(() => {
    const onClickOutside = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div ref={rootRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="relative flex h-8 w-8 items-center justify-center rounded-md text-[var(--text-muted)] hover:bg-[var(--surface-hover)] hover:text-[var(--text-default)]"
        aria-label={`Bildirimler (${count})`}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M3.5 6a4.5 4.5 0 019 0v3l1 1.5h-11l1-1.5V6z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
          <path d="M6.5 12.5a1.5 1.5 0 003 0" stroke="currentColor" strokeWidth="1.5" />
        </svg>
        {count > 0 && (
          <span className="absolute right-0 top-0 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-[var(--color-danger-500)] px-1 text-[9px] font-bold text-white">
            {count}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 top-full z-50 mt-2 w-80 overflow-hidden rounded-lg border border-[var(--sidebar-border)] bg-[var(--surface-base)] shadow-xl">
          <header className="border-b border-[var(--sidebar-border)] bg-[var(--surface-strong)] px-3 py-2">
            <h3 className="text-xs font-semibold uppercase tracking-wider text-[var(--text-muted)]">Bildirimler</h3>
          </header>
          <ul className="max-h-96 overflow-y-auto">
            {STUB_NOTIFS.map((n) => (
              <li key={n.id} className="border-b border-[var(--sidebar-border)] last:border-0">
                <Link
                  href={n.href as never}
                  onClick={() => setOpen(false)}
                  className="block p-3 hover:bg-[var(--surface-hover)]"
                >
                  <div className="flex items-start gap-2">
                    <span
                      className={`mt-1 inline-block h-2 w-2 shrink-0 rounded-full ${
                        n.severity === "blocker" ? "bg-[var(--color-danger-500)]" :
                        n.severity === "warning" ? "bg-[var(--color-warning-500)]" :
                        "bg-[var(--color-info-500)]"
                      }`}
                      aria-hidden
                    />
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-[var(--text-strong)]">{n.title}</p>
                      <p className="mt-0.5 text-xs text-[var(--text-muted)]">{n.body}</p>
                      <p className="mt-1 text-[10px] text-[var(--text-muted)]">{n.createdAgo}</p>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
          <footer className="border-t border-[var(--sidebar-border)] bg-[var(--surface-strong)] px-3 py-2 text-center">
            <Link href="/inbox" onClick={() => setOpen(false)} className="text-xs font-medium text-[var(--brand-600)] hover:text-[var(--brand-700)]">
              Tümünü gör →
            </Link>
          </footer>
        </div>
      )}
    </div>
  );
}
